// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-card__title[data-v-28c74f56] {\r\n  min-height: 36px !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
